<template>
    <el-form :model="formData" :rules="rules" ref="dataForm">
        <el-form-item label="配置名:" prop="name" :label-width="formLabelWidth">
            <el-input v-model="formData.name" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="广告图1:" prop="pic1" :label-width="formLabelWidth">
            <el-image v-if="jsonObject.pic1" style="width: 100px; height: 100px" :src="jsonObject.pic1" ></el-image>
            <el-button v-if="jsonObject.pic1" type="primary" icon="el-icon-delete" @click="deletePic('1')" ></el-button>
            <input class="file-input" type="file" ref='fileImportInput1'  @change="fileChange('1')"  />
        </el-form-item>
        <el-form-item label="图1链接:" prop="pic1Url" :label-width="formLabelWidth">
            <el-input v-model="jsonObject.pic1Url" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="广告图2:" prop="pic2" :label-width="formLabelWidth">
            <el-image v-if="jsonObject.pic2" style="width: 100px; height: 100px" :src="jsonObject.pic2" ></el-image>
            <el-button v-if="jsonObject.pic2" type="primary" icon="el-icon-delete" @click="deletePic('2')" ></el-button>
            <input class="file-input" type="file" ref='fileImportInput2'  @change="fileChange('2')"  />
        </el-form-item>
        <el-form-item label="图2链接:" prop="pic2Url" :label-width="formLabelWidth">
            <el-input v-model="jsonObject.pic2Url" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="广告图3:" prop="pic3" :label-width="formLabelWidth">
            <el-image v-if="jsonObject.pic3" style="width: 100px; height: 100px" :src="jsonObject.pic3" ></el-image>
            <el-button v-if="jsonObject.pic3" type="primary" icon="el-icon-delete" @click="deletePic('3')" ></el-button>
            <input class="file-input" type="file" ref='fileImportInput3'  @change="fileChange('3')"  />
        </el-form-item>
        <el-form-item label="图3链接:" prop="pic3Url" :label-width="formLabelWidth">
            <el-input v-model="jsonObject.pic3Url" autocomplete="off"></el-input>
        </el-form-item>

        <el-form-item label="悬浮按钮链接:" prop="flowButtonUrl" :label-width="formLabelWidth">
            <el-input v-model="jsonObject.flowButtonUrl" autocomplete="off"></el-input>
        </el-form-item>
		
		<!-- 新UI -->
		<el-form-item v-if="showNewUi == 1" label="轮播图:" prop="loopUrl" :label-width="formLabelWidth">
		    <el-image v-if="jsonObject.loopUrl" style="width: 100px; height: 100px" :src="jsonObject.loopUrl" ></el-image>
		    <el-button v-if="jsonObject.loopUrl" type="primary" icon="el-icon-delete" @click="deletePic('4')" ></el-button>
		    <input class="file-input" type="file" ref='fileImportInput4'  @change="fileChange('4')"  />
		</el-form-item>
		<el-form-item v-if="showNewUi == 1" label="跳转类型:" prop="jumpType" :label-width="formLabelWidth">
		    <el-select v-model="jsonObject.jumpType" @change="$forceUpdate()">
				<el-option label="轮播图" value="轮播图"></el-option>
				<el-option label="套餐订购" value="套餐订购"></el-option>
				<el-option label="余额充值" value="余额充值"></el-option>
			</el-select>
		</el-form-item>
		<el-form-item v-if="jsonObject.jumpType == '轮播图' && showNewUi == 1" label="轮播图跳转地址:" prop="jumpUrl" :label-width="formLabelWidth">
		    <el-input v-model="jsonObject.jumpUrl" autocomplete="off"></el-input>
		</el-form-item>
		<el-form-item v-if="showNewUi == 1" label="播报语:" prop="loopTitle" :label-width="formLabelWidth">
		    <el-input v-model="jsonObject.loopTitle" autocomplete="off"></el-input>
		</el-form-item>
		<el-form-item v-if="showNewUi == 1" label="选择优惠套餐:" :label-width="formLabelWidth">
			<el-select v-model="curMeals" multiple filterable  placeholder="请选择" @change="onChange">
			    <el-option
			      v-for="item in mealLists"
			      :key="item.mealId"
			      :label="item.mealName"
			      :value="item.mealId">
			    </el-option>
			  </el-select>
		</el-form-item>
    </el-form>
    
</template>

<script>
    import {uploadPayOfflineUrl} from "@/api/agentManagement.js"
    import {setmealListForUser} from "@/api/cardManagement/cardBill.js"
    export default {
        name: "AdContent",
        props: ['initData', "showNewUi"],
        watch: {
            jsonObject:{
                handler (newVal, oldVal) {
                    this.formData.jsonStr = JSON.stringify(newVal)
					if(newVal.meals){
						this.curMeals = [] 
						newVal.meals.forEach(item=>{
							this.curMeals.push(item.id)
						})
					}else{
						this.curMeals = []
					}
					console.log(this.formData, "一进来就调")
                },
                deep: true
            },
            initData:function (newVal, oldVal) {
				this.setmealListForUser()
                this.formData = newVal;
                this.jsonObject = JSON.parse(newVal.jsonStr)
            }
        },
        data() {
            return {
				curMeals: [],
				mealLists: [],
                formData: this.initData,
                jsonObject: this.initDataMethod(this.initData),
                formLabelWidth: "120px",
                rules: {
                    name: [{
                        required: true,
                        message: '不能为空',
                        trigger: 'blur'
                    },],
                },
                uploading: {
                    '1': false,
                    '2': false,
                    '3': false,
                    '4': false
                }
            }
        },
		created() {
			this.setmealListForUser()
			if(this.jsonObject.meals){
				this.curMeals = []
				this.jsonObject.meals.forEach(item=>{
					this.curMeals.push(item.id)
				})
			}else{
				this.curMeals = []
			}
		},
        methods:{
			onChange(){
				if(this.curMeals.length > 6){
					this.$modal.alertWarning("最多只能选择6个套餐")
					this.curMeals.pop()
				}
				let meals = []
				this.curMeals.forEach((item) => {
					this.mealLists.forEach(meal => {
						if(item == meal.mealId){
							meals.push({name:meal.mealName, id:meal.mealId})
						}
					})
				})
				this.jsonObject.meals = meals
				console.log(this.jsonObject.meals, "change meals")
				this.formData.jsonStr = JSON.stringify(this.jsonObject)
			},
			setmealListForUser(){
				setmealListForUser().then(res=>{
					this.mealLists = res
				}).catch()
			},
            initDataMethod(data){
                if (data.jsonStr == undefined || data.jsonStr == '' || data.jsonStr == '{}') {
                    return {pic1:'',pic3:'',pic2:'',pic1Url:'',pic2Url:'',pic3Url:'',flowButtonUrl:'', loopUrl:'', meals:[]}
                } else {
                    return JSON.parse(data.jsonStr)
                }
            },
            fileChange(val){
                if(this.$refs['fileImportInput'+val].files[0]){
                    let fileName = this.$refs['fileImportInput'+val].files[0].name
                    let index = fileName.lastIndexOf(".")
                    if (index < 0 || !(fileName.substring(index + 1, fileName.length) == "png" || fileName
                        .substring(index + 1, fileName.length) == "jpg"|| fileName
                        .substring(index + 1, fileName.length) == "jpeg"|| fileName
                        .substring(index + 1, fileName.length) == "svg" || fileName
                        .substring(index + 1, fileName.length) == "gif")) {
                        this.$alert('文件格式错误', '提示', {
                            confirmButtonText: '确定',
                        });
                        return
                    }
                    
                    this.$set(this.uploading, val, true)
                    
                    const loadingInstance = this.$loading({
                        lock: true,
                        text: '图片上传中...',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)'
                    });
                    
                    let param = new FormData()
                    param.append("file", this.$refs['fileImportInput'+val].files[0])
                    uploadPayOfflineUrl(param).then(res=>{
						if(val == 4){
							this.jsonObject['loopUrl'] = res.url
						}else{
							this.jsonObject['pic'+val] = res.url
						}
                        this.$forceUpdate()
                        this.formData.jsonStr = JSON.stringify(this.jsonObject)
                        
                        this.$message({
                            message: '上传成功',
                            type: 'success'
                        });
                    }).catch(err => {
                        this.$message.error('上传失败，请重试');
                        console.error(err);
                    }).finally(() => {
                        loadingInstance.close();
                        this.$set(this.uploading, val, false);
                    })
                }
            },
            deletePic(val) {
                if(val == '4') {
                    this.jsonObject.loopUrl = '';
                } else {
                    this.jsonObject['pic'+val] = '';
                }
                
                // 重置文件输入框的值
                this.$refs['fileImportInput'+val].value = '';
                
                // 更新数据
                this.$forceUpdate();
                this.formData.jsonStr = JSON.stringify(this.jsonObject);
            },
        }
    }
</script>

<style scoped>

</style>